import { PropsWithChildren } from 'react'
import css from './button.module.css'
import CircleLoader from '../../Loaders/CircleLoader'

interface IProps {
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
}

const Button = (props: PropsWithChildren<IProps>) => {
  const handleClick = (ev) => {
    ev.stopPropagation()
    if (props.disabled || props.loading) return

    props.onClick()
  }

  const renderLoader = () => {
    return (
      <div className={css.loader}>
        <CircleLoader />
      </div>
    )
  }

  return (
    <button
      className={css.button}
      onClick={handleClick}
      disabled={props.disabled ?? false}
      data-disabled={props.disabled}
    >
      <span style={{ visibility: props.loading ? 'hidden' : 'visible' }}>{props.children}</span>
      {props.loading && renderLoader()}
    </button>
  )
}

export default Button
